import CmsStoreActions from '../actions/CmsStoreActions';

export const fetchCmsData = (slug: string) => {
  CmsStoreActions.getCmsData(slug);
};
